import { PersonStore } from "../../store/modules/person";
import { DiTokens } from "../../services/diTokens";
import IAlertService from "../../services/alert/IAlertService";
import Vue from "vue";
import { PersonApi } from "../../services/api/PersonApi";
import { OperationsApi } from "../../services/api/OperationsApi";
import { getModule } from "vuex-module-decorators";
import { container } from "@/inversify.config";
import i18n from "@/i18n";

export class DocumentsModalVue extends Vue {
  /** Стор профиля */
  get personStore(): PersonStore {
    return getModule(PersonStore, this.$store);
  }

  get alertService(): IAlertService {
    return container.get<IAlertService>(DiTokens.AlertService);
  }

  docsList: Array<any> = [];

  async init(): Promise<void> {
    this.docsList = [];
    try {
      const res: any = await PersonApi.getPersonDocuments();
  
      if (res.data && res.data.length) {
        for(let i = 0; i < res.data.length; i++) {
          const item: any = res.data[i];

          if (item)
            this.docsList.push(item);
        }
      }

    } catch (e: any) {
      this.alertService.error(e.message);
    }
  }

  async downloadDoc(doc: any) {
    if (doc) {
      try {
        const res: any = await OperationsApi.getDocumentFileData(doc.Id, doc.Name);
      } catch (e: any) {
        this.alertService.error(e.message);
      }
    }
  }


  destroyOperation() {
    this.$emit("hideSelf");
  }
}
